import React from "react"
import {
  FaLinkedin,
  FaInstagramSquare,
  FaTelegramPlane,
  FaGithubSquare,
  FaEnvelopeSquare,
} from "react-icons/fa"

const data = [
  {
    id: 1,
    icon: <FaGithubSquare className="social-icon"></FaGithubSquare>,
    url: "https://github.com/shreyanksinghal",
  },
  {
    id: 2,
    icon: <FaInstagramSquare className="social-icon"></FaInstagramSquare>,
    url: "https://www.instagram.com/shreyank_singhal/",
  },
  {
    id: 3,
    icon: <FaLinkedin className="social-icon"></FaLinkedin>,
    url: "https://www.linkedin.com/in/shreyank-singhal/",
  },
  {
    id: 4,
    icon: <FaTelegramPlane className="social-icon"></FaTelegramPlane>,
    url: "https://t.me/shreyank_singhal",
  },
  {
    id: 5,
    icon: <FaEnvelopeSquare className="social-icon"></FaEnvelopeSquare>,
    url: "mailto:shreyanksinghal2000@gmail.com",
  },
]
const links = data.map(link => {
  return (
    <li key={link.id}>
      <a href={link.url} target="__blank" className="social-link">
        {link.icon}
      </a>
    </li>
  )
})

export default ({ styleClass }) => {
  return (
    <ul className={`social-links ${styleClass ? styleClass : ""}`}>{links}</ul>
  )
}
